import { useFormContext } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/shared/ui/form";
import { Input } from "@/shared/ui/input";
import { Button } from "@/shared/ui/button";
import { SignupFormValues } from "@/shared/lib/validation/user-schemas";
import { useState } from "react";
import { useTranslations } from "next-intl";

interface PasswordStepProps {
  onSubmit: () => void;
}

export function PasswordStep({ onSubmit }: PasswordStepProps) {
  const form = useFormContext<SignupFormValues>();
  const t = useTranslations();

  const [confirmPassword, setConfirmPassword] = useState("");
  const password = form.watch("password");

  const passwordMatch = password && confirmPassword && password === confirmPassword;
  const showPasswordMatchError = confirmPassword && !passwordMatch;

  const handleSubmit = async () => {
    // 비밀번호 관련 필드 검증
    const isValid = await form.trigger(["password"]);
    if (isValid && passwordMatch) {
      onSubmit();
    }
  };

  return (
    <div className="pc:max-w-[420px] w-full">
      <h3 className="heading-3-bold pc:mb-10 mb-8 text-center text-gray-900">{t("f_pw")}</h3>
      <div className="tb:space-y-6 space-y-3">
        {/* 이메일 표시 (수정 불가) */}
        <div>
          <FormLabel className="body-md-bold tb:mb-2 mb-[6px] text-gray-900">{t("f_pw_lable_id")}</FormLabel>
          <div className="rounded-10 tb:py-[13px] w-full border border-gray-200 bg-gray-50 px-4 py-[10px] text-gray-400">
            {form.watch("email")}
          </div>
        </div>

        {/* 비밀번호 입력 */}
        <FormField
          control={form.control}
          name="password"
          render={({ field }) => (
            <FormItem>
              <FormLabel htmlFor="password" className="body-md-bold text-gray-900">
                {t("f_pw_lable_pw")}
              </FormLabel>
              <FormControl>
                <Input
                  id="password"
                  variant="public"
                  type="password"
                  placeholder={t("f_pw_placeholder_pw")}
                  value={field.value || ""}
                  onChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />

        {/* 비밀번호 확인 */}

        <FormItem>
          <FormLabel htmlFor="confirmPassword" className="body-md-bold text-gray-900">
            {t("f_pw_lable_pc")}
          </FormLabel>
          <FormControl>
            <Input
              id="confirmPassword"
              variant="public"
              type="password"
              placeholder={t("f_pw_placeholder_pc")}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </FormControl>
          {form.formState.errors.password && (
            <span className="body-sm-regular text-red-500">{form.formState.errors.password.message}</span>
          )}
          {showPasswordMatchError && <span className="body-sm-regular text-red-500">{t("f_pw_err_pw_2")}</span>}
        </FormItem>
      </div>

      <Button type="button" className="mt-10 w-full" variant="primary" size="lg" onClick={handleSubmit}>
        {t("f_pw_btn_nt")}
      </Button>
    </div>
  );
}
